import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { AppSwitcher, SwxTheme, Box } from 'swx-atomic-component-lib'
import i18n from '../i18n'

class SignUpForEnterprise extends Component {
  render () {
    const { x3 } = SwxTheme.sizing

    return (
      <Box display='flex' justifyContent='center'>
        <AppSwitcher
          w='60%'
          customStyle={`
            border-radius: 5px;
            background: ${SwxTheme.palette.g100};
            a { 
              border: 1px solid ${SwxTheme.palette['secondary-dark']};
            }
          `}
          mb={x3}
          rounded
          title={i18n.appLauncher.enterprise.title}
          subTitle={i18n.appLauncher.enterprise.subTitle}
          action={{
            label: i18n.appLauncher.enterprise.button,
            buttonProps: {
              renderAs: Link,
              to: '/enterprise',
              secondary: true
            }
          }}
          iconUrl='/symbol-color.svg'
        />
      </Box>
    )
  }
}

function mapStateToProps (state) {
  // Whatever is returned will show up as props inside props of this component
  return {
    self: state.self
  }
}

export default connect(mapStateToProps)(SignUpForEnterprise)
